import { createFormHook, createFormHookContexts } from "@tanstack/react-form";
import { EmailField } from "./components/email-field";
import { NumberField } from "./components/number-field";
import { SubmitButton } from "./components/submit-button";
import { TextField } from "./components/text-field";

export const { fieldContext, useFieldContext, formContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField,
    NumberField,
    EmailField,
  },
  formComponents: {
    SubmitButton,
  },
});
